import { render } from "./HomeOnePage.vue?vue&type=template&id=3586edfd"
import script from "./HomeOnePage.vue?vue&type=script&lang=js"
export * from "./HomeOnePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__